/* Print Phuket global footer (14 Oct 2026): mobile accordions, wordmark "registration", CTA analytics. No dependencies. */
(function () {
  var f = document.querySelector('[data-ppf]');
  if (!f) return;
  var mq = window.matchMedia('(max-width: 749px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Accordions: open on tablet/desktop (summary inert), collapsed on phones. Links stay in the HTML for crawlers. */
  var cols = [].slice.call(f.querySelectorAll('[data-ppf-acc]'));
  function sync() {
    cols.forEach(function (d) {
      if (mq.matches) { d.removeAttribute('open'); } else { d.setAttribute('open', ''); }
    });
  }
  cols.forEach(function (d) {
    d.querySelector('summary').addEventListener('click', function (e) { if (!mq.matches) e.preventDefault(); });
  });
  sync();
  (mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync));

  /* Wordmark: starts slightly out of register, snaps into register when it scrolls into view; drifts a touch with the pointer. */
  var mark = f.querySelector('[data-ppf-mark]');
  if (mark && !reduce.matches && 'IntersectionObserver' in window) {
    mark.classList.add('is-off');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) {
          setTimeout(function () { mark.classList.remove('is-off'); }, 150);
          setTimeout(function () { mark.classList.add('is-live'); }, 1300);
          io.disconnect();
        }
      });
    }, { threshold: 0.35 });
    io.observe(mark);
    if (window.matchMedia('(hover: hover)').matches) {
      var raf;
      mark.addEventListener('pointermove', function (e) {
        if (!mark.classList.contains('is-live')) return;
        var r = mark.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var s = mark.style;
          s.setProperty('--cx', (-x * 10).toFixed(1) + 'px'); s.setProperty('--cy', (-y * 5).toFixed(1) + 'px');
          s.setProperty('--mx', (x * 10).toFixed(1) + 'px'); s.setProperty('--my', (y * 5).toFixed(1) + 'px');
          s.setProperty('--yx', (x * 3).toFixed(1) + 'px'); s.setProperty('--yy', (y * 8).toFixed(1) + 'px');
        });
      });
      mark.addEventListener('pointerleave', function () {
        ['--cx', '--cy', '--mx', '--my', '--yx', '--yy'].forEach(function (p) { mark.style.removeProperty(p); });
      });
    }
  }

  /* Let fixed bars (product sticky price bar) step aside at the very end of the page. */
  var end = f.querySelector('.ppf-mark') || f;
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      document.documentElement.classList.toggle('ppf-end', es[0].isIntersecting || es[0].boundingClientRect.top < 0);
    }).observe(end);
  }

  /* The footer has its own WhatsApp/LINE buttons: hide the floating chat widget while the footer fills the lower screen so it never covers footer links. */
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      document.documentElement.classList.toggle('ppf-in', es[0].isIntersecting);
    }, { rootMargin: '0px 0px -35% 0px' }).observe(f);
  }

  /* Analytics: same event name as the homepage/contact CTAs, tagged with location=footer. */
  f.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ppf-cta]');
    if (!a) return;
    var d = { event: 'pp_cta_click', cta: a.getAttribute('data-ppf-cta'), label: a.textContent.trim(), href: a.href, location: 'footer' };
    try { (window.dataLayer = window.dataLayer || []).push(d); } catch (x) {}
    try { window.Shopify && Shopify.analytics && Shopify.analytics.publish && Shopify.analytics.publish('pp_cta_click', d); } catch (x) {}
  });
})();
